import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { AppWrapper, renderApp } from '@/utils/createApp';
import { getBaseName } from '@/utils';
import { PrivateOutlet } from '@/components/Auth/PrivateRoute';
import { AdvertiserTerms, IpTransferAgreement, AgreementFromTcc, FundedTerms } from '@/components/Agreement';
import { AgreementID } from '@/containers/BusinessRelatedParams/consts';
import PackagesPage from '@/containers/Agreements/PackagesPage';

const hotModule = module as any;
if (hotModule.hot) {
  hotModule.hot.accept();
}

const tccTerms = [
  {
    path: 'partner-agreement',
    id: AgreementID.Partner
  },
  {
    path: 'partner-shared-folder',
    id: AgreementID.SharedFolderWithoutRevShare
  },
  {
    path: 'partner-shared-folder-with-rev-share',
    id: AgreementID.SharedFolderWithRevShare
  },
  {
    path: 'partner-subscription-agreement',
    id: AgreementID.SubscriptionAddendumForPartner
  },
  {
    path: 'advertiser-platform-agreement',
    id: AgreementID.AdvertiserPlatformTerm
  },
  {
    path: 'partner-platform-agreement',
    id: AgreementID.PartnerPlatformTerm
  },
  {
    path: 'video-content-package-agreement',
    aliasPath: 'advertiser-agreement', // for supporting legacy paths
    id: AgreementID.TTCXPackageTerm
  }
];

const otherTerms = [
  {
    path: 'ip-transfer-agreement',
    element: <IpTransferAgreement />
  },
  {
    path: 'terms-advertiser',
    element: <AdvertiserTerms />
  },
  {
    path: 'funded-terms',
    element: <FundedTerms />
  }
];

const TermsSwitch = () => {
  const params = useParams();
  for (const tccTerm of tccTerms) {
    if (
      params.name?.startsWith(tccTerm.path) ||
      (tccTerm.aliasPath && params.name?.startsWith(tccTerm.aliasPath))
    ) {
      return <AgreementFromTcc id={tccTerm.id} />;
    }
  }

  for (const term of otherTerms) {
    if (params.name?.startsWith(term.path)) {
      return term.element;
    }
  }

  return <>{params.name}</>;
};

function TermsPage() {
  return (
    <Routes>
      <Route path="/" element={<PrivateOutlet />}>
        <Route path=":name" element={<TermsSwitch />} />
      </Route>
      <Route path="ttcx-packages" element={<PackagesPage />} />
    </Routes>
  );
}

const basename = getBaseName('terms');

renderApp(
  <AppWrapper baseName={basename} title="TikTok Creative Exchange" Component={TermsPage} />,
  document.getElementById('root')!
);
